import { IconName } from '@frontend/icons';
import { theme } from '@frontend/theme';

export interface ForYouFilterType {
  id: string;
  displayName: string;
  iconName: IconName;
  component: ({ closePopOver }: { closePopOver: () => void }) => JSX.Element;
  hide: boolean;
}

export interface PaletteColorType {
  color: string;
  backgroundColor: string;
  textColor: string;
}

export const PaletteColors: Record<string, PaletteColorType> = {
  neutral: {
    color: 'neutral',
    textColor: theme.colors.neutral50,
    backgroundColor: theme.colors.neutral5,
  },
  success: {
    color: 'success',
    textColor: theme.colors.success50,
    backgroundColor: theme.colors.success5,
  },
  seaweed: {
    color: 'seaweed',
    textColor: theme.colors.secondary.seaweed50,
    backgroundColor: theme.colors.secondary.seaweed5,
  },
  primary: {
    color: 'primary',
    textColor: theme.colors.primary50,
    backgroundColor: theme.colors.primary5,
  },
  indigo: {
    color: 'indigo',
    textColor: theme.colors.indigo50,
    backgroundColor: theme.colors.indigo5,
  },
  eggplant: {
    color: 'eggplant',
    textColor: theme.colors.secondary.eggplant50,
    backgroundColor: theme.colors.secondary.eggplant5,
  },
  rose: {
    color: 'rose',
    textColor: theme.colors.rose50,
    backgroundColor: theme.colors.rose5,
  },
  critical: {
    color: 'critical',
    textColor: theme.colors.critical50,
    backgroundColor: theme.colors.critical5,
  },
  tangerine: {
    color: 'tangerine',
    textColor: theme.colors.tangerine40,
    backgroundColor: theme.colors.tangerine5,
  },
  warning: {
    color: 'warning',
    textColor: theme.colors.warning30,
    backgroundColor: theme.colors.warning5,
  },
};

export const PaletteColorValues = Object.values(PaletteColors);
